export const BASE_URL = process.env.REACT_APP_XCHANGE_BASE_URL;
export const XCHANGE_PLATFORM_NAME =
  process.env.REACT_APP_XCHANGE_PLATFORM_NAME;
export const MEETING_SUITE_NAME = process.env.REACT_APP_MEETING_SUITE_NAME;
export const APP_EVENT_ID = process.env.REACT_APP_EVENT_ID;
export const APP_EVENT_NAME = process.env.REACT_APP_EVENT_NAME;
export const APP_EVENT_SUMMIT_URL = process.env.REACT_APP_EVENT_SUMMIT_URL;
export const APP_BRAND_CONTACT_EMAIL_ADDR =
  process.env.REACT_APP_BRAND_CONTACT_EMAIL_ADDR;
export const APP_BRAND_PUB_ID = process.env.REACT_APP_BRAND_PUB_ID;
export const APP_BRAND_NAME = process.env.REACT_APP_BRAND_NAME;
export const APP_BRAND_FOLDER = process.env.REACT_APP_BRAND_FOLDER;
export const HAS_EVENT_TIMEZONE_SUPPORT =
  process.env.REACT_APP_EVENT_TIMEZONE_SUPPORT;
export const SIDENAV_PEOPLE_LABEL = process.env.REACT_APP_SIDENAV_PEOPLE_LABEL;

// Meeting room params for Whereby
export const MEETING_QUERY_PARAMS_GUESTS = `embed&background=off&chat=off&people=off&leaveButton=off&help=off&precallReview=off&recording=off&screenshare=off&video=on&iframeSource=${process.env.REACT_APP_WHEREBY_IFRAME_SOURCE}`;
export const MEETING_QUERY_PARAMS = `embed&background=off&chat=on&people=off&leaveButton=off&help=off&precallReview=off&recording=off&screenshare=on&video=on&iframeSource=${process.env.REACT_APP_WHEREBY_IFRAME_SOURCE}`;
export const REAL_SCREEN = "Realscreen";
export const BRAND = {
  REAL_SCREEN: "Realscreen",
  KID_SCREEN: "Kidscreen",
  BANFF: "Banff",
  CIX: "CIX",
};

export const GOOGLE_ANALYTICS_KEY = process.env.REACT_APP_BRAND_GA_KEY;

export const REACT_APP_SERVER_BASE_URL = process.env.REACT_APP_API_ENDPOINT.split('/api')[0]; 

export const colorPalette = [
  "#1E77B4",
  "#16d18d",
  "#32A02B",
  "#E3191B",
  "#693D9A",
  "#B15927",
  "#A6CEE3",
  "#2B8889",
  "#FB9B99",
  "#FDBF6F",
  "#CAB2D6",
  "#EA7A57",
  "#DF5286",
  "#865FCF",
  "#d0d000",
  "#5f2a41",
  "#FF7F00",
  "#3b13e0",
  "#1387c4",
  "#84df8a",
  "#78a7c7",
  "#b2c3ae",
  "#db10aa",
  "#bae910",
  "#eeaaff",
  "#3bf3df",
];

export const MEETING_LOCATIONS = {
  MEETING_SUITE: "Meeting Suite/Pavilion",
  PERSONAL_ROOM: "Personal Conference Room",
  DELEGATE_LOUNGE: "Delegate Lounge",
};